import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Link } from 'react-router-dom';
import AnimatedCounter from '../../components/AnimatedCounter/AnimatedCounter';
import ReviewSlider    from '../../components/ReviewSlider/ReviewSlider';
import useScrollReveal from '../../hooks/useScrollReveal';
import { reviews }     from '../../data/reviews';

import buildingImg  from '../../assets/building.jpg';
import aerospaceImg from '../../assets/aerospace.jpg';
import windmillImg  from '../../assets/windmill.jpg';
import milltechLogo from '../../assets/miltech logo.png';
import expCNC       from '../../assets/Engineering excelency/cnc machine.jpg';
import expFab       from '../../assets/Engineering excelency/heavy fabrication.jpg';
import expInspect   from '../../assets/Engineering excelency/Dimensional Inspection.jpg';
import expAero      from '../../assets/Engineering excelency/Aerospace Certified.jpg';
import expCam       from '../../assets/Engineering excelency/MasterCAM Programming.jpg';
import expISO       from '../../assets/Engineering excelency/ISO.jpg';
import visionImg   from '../../assets/Our Vision.jpg';
import missionImg  from '../../assets/our_mission-removebg-preview.png';
import qualityImg  from '../../assets/quality-removebg-preview.png';
import logoFLSmidth from '../../assets/miltech logo/FLSmidth.png';
import logoIGCAR    from '../../assets/miltech logo/Indira_Gandhi_Centre_for_Atomic_Research_Logo.png';
import logoLT       from '../../assets/miltech logo/L&T (DEFENCE, ECC, Rubber Processing Machinery), Chennai..png';
import logoLPSC     from '../../assets/miltech logo/Liquid_Propulsion_Systems_Centre_Logo.png';
import logoVSSC     from '../../assets/miltech logo/VIKRAM SARABHAI SPACE RESEARCH CENTRE, Thiruvananthapuram. logo.png';
import logoBrahmos from '../../assets/miltech logo/BrahMos_Aerospace.svg.png';

import './Home.css';

/* ── Banner slides ── */
const SLIDES = [
  {
    img: aerospaceImg,
    label: 'Aerospace',
    tag: 'ISRO · BrahMos · PSLV · Gaganyaan',
    title: ['CNC', 'Aerospace', 'Engineering'],
    sub: 'Critical aerospace components manufactured to ISRO-grade specifications with zero-tolerance quality.',
    accent: '#4F46E5',
  },
  {
    img: windmillImg,
    label: 'Wind Energy',
    tag: 'Renewable · Heavy Machining',
    title: ['Heavy Duty', 'Wind Turbine', 'Components'],
    sub: 'Large nacelle frames, hub flanges and structural parts machined on our 12.5m KOLB Gantry.',
    accent: '#10B981',
  },
  {
    img: buildingImg,
    label: 'Infrastructure',
    tag: 'Heavy Fabrication · Thermal Plants',
    title: ['Industrial', 'Infrastructure', 'Solutions'],
    sub: 'High-pressure tanks, earth-moving equipment and thermal power plant components since 2002.',
    accent: '#F59E0B',
  },
];

const CLIENTS = [
  { abbr: 'ISRO / VSSC', logo: logoVSSC,     color: '#F59E0B' },
  { abbr: 'BrahMos',     logo: logoBrahmos,  color: '#4F46E5' },
  { abbr: 'L&T',         logo: logoLT,       color: '#E8192C' },
  { abbr: 'IGCAR',       logo: logoIGCAR,    color: '#10B981' },
  { abbr: 'FLSmidth',    logo: logoFLSmidth, color: '#0EA5E9' },
  { abbr: 'LPSC',        logo: logoLPSC,     color: '#7C3AED' },
];

const EXPERTISE = [
  { img: expCNC,     title: 'CNC Machining',         desc: '0.02mm tolerances on aerospace-grade alloys',    color: '#4F46E5' },
  { img: expFab,     title: 'Heavy Fabrication',      desc: 'Up to 100T on our BERTHIEZ 8.2m VTL',           color: '#E8192C' },
  { img: expInspect, title: 'Dimensional Inspection', desc: 'TESA, Pi-tape, tubular micrometers to 5000mm',  color: '#10B981' },
  { img: expAero,    title: 'Aerospace Certified',    desc: 'ISRO-approved, Gaganyaan & PSLV components',    color: '#F59E0B' },
  { img: expCam,     title: 'MasterCAM Programming',  desc: 'In-house 4/5-axis CNC programming expertise',   color: '#7C3AED' },
  { img: expISO,     title: 'ISO 9001:2015',          desc: 'Certified quality management, full traceability', color: '#EA580C' },
];

/* Unit location cards */


/* ── BANNER HERO ── */
function BannerHero() {
  const [current, setCurrent] = useState(0);
  const [prev,    setPrev]    = useState(null);
  const [, setAnimDir]        = useState('next');
  const timerRef = useRef(null);

  const goTo = useCallback((idx, dir = 'next') => {
    setPrev(current);
    setAnimDir(dir);
    setCurrent(idx);
    window.dispatchEvent(new CustomEvent('bannerSlideChange', { detail: idx }));
  }, [current]);

  useEffect(() => {
    timerRef.current = setInterval(() => {
      setCurrent(c => {
        const next = (c + 1) % SLIDES.length;
        setPrev(c); setAnimDir('next');
        window.dispatchEvent(new CustomEvent('bannerSlideChange', { detail: next }));
        return next;
      });
    }, 5500);
    return () => clearInterval(timerRef.current);
  }, []);

  const slide = SLIDES[current];

  return (
    <section className="banner-hero">
      {SLIDES.map((s, i) => (
        <div key={i} className={`banner-slide ${i === current ? 'banner-slide--active' : ''} ${i === prev ? 'banner-slide--prev' : ''}`}>
          <img src={s.img} alt={s.label} className="banner-slide__img" />
          <div className="banner-slide__overlay" 
          style={{ background: 'linear-gradient(135deg, rgba(10,15,25,0.4) 0%, rgba(10,15,25,0.4) 20%, rgba(10,10,10,0.2))' }} />
        </div>
      ))}

      <div className="container banner-hero__content">
        <div className="banner-pill" style={{ borderColor: `${slide.accent}55` }}>
          <span className="banner-pill-dot" style={{ background: slide.accent }} />
          <span>{slide.tag}</span>
        </div>

        <h1 className="banner-title">
          {slide.title.map((line, i) => (
            <span
  key={`${current}-${i}`}
  className={`banner-title__line banner-title__line--${i} banner-word-reveal`}
  style={i === 1 ? { color: '#f39b3c' } : {}}>{line}</span>
          ))}
        </h1>

        <p className="banner-sub banner-word-reveal" style={{ animationDelay: '0.35s' }}>{slide.sub}</p>

        <div className="banner-btns">
          <Link to="/products" className="btn btn-red">Explore Products</Link>
          <Link to="/contact"  className="btn btn-ghost">Get a Quote →</Link>
        </div>

        <div className="banner-tags">
          {['ISRO Supplier', 'BrahMos Approved', 'Gaganyaan Programme', 'ISO Certified'].map(t => (
            <span key={t} className="banner-tag">{t}</span>
          ))}
        </div>

        {/* ── UNIT CARDS — compact, inside hero ── */}
       
      </div>

      <div className="banner-dots">
        {SLIDES.map((s, i) => (
          <button
            key={i}
            className={`banner-dot ${i === current ? 'banner-dot--active' : ''}`}
            style={{ '--dc': SLIDES[i].accent }}
            onClick={() => goTo(i, i > current ? 'next' : 'prev')}
          >
            <span className="banner-dot__label">{s.label}</span>
            {i === current && <span className="banner-dot__progress" />}
          </button>
        ))}
      </div>

   

      <div className="banner-wave">
        <svg viewBox="0 0 1440 80" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
          <path d="M0,40 C360,80 1080,0 1440,40 L1440,80 L0,80 Z" fill="#F8FAFE"/>
        </svg>
      </div>
    </section>
  );
}

export default function Home() {
  const statsRef   = useScrollReveal();
  const expRef     = useScrollReveal();
  const aboutRef   = useScrollReveal();
  const qualityRef = useScrollReveal();
  const ctaRef     = useScrollReveal();

  return (
    <div className="home">

      {/* ══ BANNER HERO ══ */}
      <BannerHero />

      {/* ══ STATS ══ */}
      <section className="stats-section" ref={statsRef}>
        <div className="container">
          <div className="stats-grid stagger">
            {[
              { v: 25,  s: '+', l: 'Years Experience', sub: 'Est. 2002' },
              { v: 2,   s: '',  l: 'CNC Facilities',   sub: 'Thirumudivakkam' },
              { v: 6,   s: '+', l: 'Tier-1 Clients',   sub: 'ISRO · BrahMos · L&T' },
              { v: 100, s: 'T', l: 'Max Machine Cap',  sub: 'BERTHIEZ VTL' },
            ].map((s, i) => (
              <div key={i} className="stat-card glass reveal">
                <div className="stat-card__top"/>
                <AnimatedCounter value={s.v} suffix={s.s} label={s.l} sublabel={s.sub}/>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══ MILESTONES ══ */}
      <section className="milestones-section">
        <div className="container milestones-inner">
        
          <h2 className="section-title" style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
            Manufacturing Units
          </h2>
          <div className="milestones-grid">
            {[
              {
                unit: 'Unit I',
                year: '2002',
                title: 'VMC & CNC Machining',
                desc: '3D Machining VMC Job Works · VMC Table 2000×1000×1000 · 4th Axis · CNC & VMC Machines · TIG, CO₂, ARC Welding',
                map: 'https://www.google.com/maps?vet=10CAAQoqAOahcKEwioutn1mKKVAxUAAAAAHQAAAAAQCQ..i&pvq=Cg0vZy8xMWZteTBtbnIxIhIKDG1pbHRlY2ggY25jMRACGAM&lqi=CgxtaWx0ZWNoIGNuYzFI4aWn0M-tgIAIWhYQABABGAAYASIMbWlsdGVjaCBjbmMxkgEQY29ycG9yYXRlX29mZmljZQ&fvr=1&cs=0&um=1&ie=UTF-8&fb=1&gl=in&sa=X&ftid=0x3a5267473fc40905:0x11649cef00b96a27',
                addr: '101/1, 14th Main Road, SIDCO Industrial Estate, Thirumudivakkam, Chennai – 600 132',
                clr: '#1E3A8A',
              },
              {
                unit: 'Unit II',
                year: '2014',
                title: 'Heavy Duty Machining',
                desc: 'CNC VTL Berthiez Ø 8200mm · Table Dia 4000mm · Max 100 Ton · CNC Gantry Floor Boring · Spindle Dia 225mm · X-Axis 14000mm',
                map: 'https://www.google.com/maps/place/MILLTECH+CNC+---UNIT+2/@12.9645983,80.0830425,17z/data=!3m1!4b1!4m6!3m5!1s0x3a52f5400a72f09d:0x645c791a6668f1a4!8m2!3d12.9645931!4d80.0856174!16s%2Fg%2F11flhf5kmd?entry=ttu&g_ep=EgoyMDI2MDYyMi4wIKXMDSoASAFQAw%3D%3D',
                addr: 'Plot No. 28, Arul Murugan Nagar, MKB Industrial Estate, Thirumudivakkam',
                clr: '#C8102E',
              },
            ].map((m, i) => (
              <div key={i} className="milestone-card" style={{ '--mc': m.clr }}>
                <div className="milestone-card__year">{m.year}</div>
                <div className="milestone-card__body">
                  <span className="milestone-card__unit">{m.unit}</span>
                  <h3 className="milestone-card__title">{m.title}</h3>
                  <p className="milestone-card__desc">{m.desc}</p>
                  <p className="milestone-card__addr">📍 {m.addr}</p>
                  <a href={m.map} target="_blank" rel="noopener noreferrer" className="milestone-card__btn">
                    View on Map →
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══ EXPERTISE ══ */}
      <section className="section bg-indigo-lt" ref={expRef}>
        <div className="container">
          <div className="exp-layout">
            <div className="exp-text reveal from-left">
              
              <h2 className="section-title">Engineering<br/>Excellence &amp;<br/><span className="text-red">Accuracy</span></h2>
              <div className="line-red"/>
              <p className="section-sub">Two specialised CNC units with machines from France, Germany, Japan and Taiwan.</p>
              <Link to="/machines" className="btn btn-indigo" style={{ marginTop: '1.5rem' }}>Explore Machines →</Link>
            </div>
            <div className="exp-grid stagger">
              {EXPERTISE.map((e, i) => (
                <div key={i} className="exp-card reveal" style={{ '--ec': e.color }}>
                  <div className="exp-card__img-bg">
                    <img src={e.img} alt={e.title} />
                    <div className="exp-card__img-overlay" style={{ background: `linear-gradient(135deg, ${e.color}22, ${e.color}44)` }} />
                  </div>
                  <div className="exp-card__body">
                    <div className="exp-card__accent" style={{ background: e.color }} />
                    <h3 className="exp-card__title">{e.title}</h3>
                    <p className="exp-card__desc">{e.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ══ ABOUT ══ */}
      <section className="about-section section bg-white" ref={aboutRef}>
        <div className="container">
          <div className="about-grid">
            <div className="about-images reveal from-left">
              <div className="about-img-primary">
                <img src={aerospaceImg} alt="MILLTECH CNC aerospace work"/>
                <div className="about-img-caption">Aerospace Components · MILLTECH CNC</div>
              </div>
              <div className="about-img-secondary">
                <img src={buildingImg} alt="MILLTECH CNC facility"/>
                <div className="about-img-caption-sm">Our Facility — Thirumudivakkam</div>
              </div>
              <div className="about-logo-badge float-anim">
                <img src={milltechLogo} alt="MILLTECH CNC" style={{ width: '60px', height: '60px', objectFit: 'contain' }} />
              </div>
            </div>

            <div className="about-body reveal from-right">
              
              <h2 className="section-title">Engineering Excellence<br/><span className="text-indigo">Since 2002</span></h2>
              <div className="line-ind"/>
              <p className="about-p">
                MILLTECH CNC is established in the year 2002 with a bold and innovative high-tech initiation of
                well-qualified MILLTECH Engineers. We started functioning from our CNC Machining Unit I
                Thirumudivakkam and added the second Heavy Duty Machining unit at Thirumudivakkam.
                We got ISO 9001:2015 certification for our Unit I.
              </p>
              <p className="about-p" style={{color:'var(--txt-3)'}}>
                More than 25 years of experience in providing high quality heavy and critical Fabrication,
                machining, Assembly, Surface Treatment, Painting for ISRO, BrahMos, Earth moving Equipment,
                Thermal power plant High Pressure Tanks, Valve Bodies, Impellers, Defence Products, and
                high accuracy aerospace components.
              </p>

              <div className="about-units">
                <a className="about-unit" href="https://www.google.com/maps?vet=10CAAQoqAOahcKEwioutn1mKKVAxUAAAAAHQAAAAAQCQ..i&pvq=Cg0vZy8xMWZteTBtbnIxIhIKDG1pbHRlY2ggY25jMRACGAM&lqi=CgxtaWx0ZWNoIGNuYzFI4aWn0M-tgIAIWhYQABABGAAYASIMbWlsdGVjaCBjbmMxkgEQY29ycG9yYXRlX29mZmljZQ&fvr=1&cs=0&um=1&ie=UTF-8&fb=1&gl=in&sa=X&ftid=0x3a5267473fc40905:0x11649cef00b96a27" target="_blank" rel="noopener noreferrer">
                  <span className="about-unit__tag">Unit I</span>
                  <span className="about-unit__year">Est. 2002</span>
                  <p>3D Machining · VMC · CNC · Welding Works</p>
                </a>
                <a className="about-unit" href="https://www.google.com/maps/place/MILLTECH+CNC+---UNIT+2/@12.9645983,80.0830425,17z/data=!3m1!4b1!4m6!3m5!1s0x3a52f5400a72f09d:0x645c791a6668f1a4!8m2!3d12.9645931!4d80.0856174!16s%2Fg%2F11flhf5kmd?entry=ttu&g_ep=EgoyMDI2MDYyMi4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener noreferrer">
                  <span className="about-unit__tag">Unit II</span>
                  <span className="about-unit__year">Est. 2014</span>
                  <p>BERTHIEZ VTL · CNC Gantry Floor Boring · Heavy Components</p>
                </a>
              </div>

              <div className="about-vmq">
                {[
                  { img: visionImg,  heading:'Our Vision',    text:'To become a leader in products and services of Special Machining and Fabrication.', color: 'var(--indigo)' },
                  { img: missionImg, heading:'Our Mission',   text:'Drive continuous improvement utilizing Lean Manufacturing principles.', color: 'var(--red)' },
                  { img: qualityImg, heading:'Quality Policy', text:'Consistently provide Products and Services that achieve Total Customer Satisfaction.', color: 'var(--emerald)' },
                ].map((v, i) => (
                  <div key={i} className="about-vmq__item">
                    <div style={{ width: '40px', height: '40px', flexShrink: 0 }}>
                      <img src={v.img} alt={v.heading} style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: '6px' }} />
                    </div>
                    <div>
                      <strong style={{color: v.color}}>{v.heading}</strong>
                      <p>{v.text}</p>
                    </div>
                  </div>
                ))}
              </div>

              <Link to="/about" className="btn btn-outline" style={{ marginTop: '2rem' }}>Learn More →</Link>
            </div>
          </div>
        </div>
      </section>

      {/* ══ MAJOR CLIENTS MARQUEE ══ */}
      <section className="clients-section">
        <div className="container" style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
          <p className="eyebrow" style={{ justifyContent: 'center' }}>Trusted By India's Best</p>
          <h2 className="section-title" style={{ fontSize: '1.8rem' }}>Major Clients</h2>
        </div>
        <div className="marquee-wrap">
          <div className="marquee-track">
            {[...CLIENTS, ...CLIENTS].map((c, i) => (
              <div key={i} className="marquee-card" style={{ '--mc': c.color }}>
                <div className="marquee-card__glow"/>
                <img src={c.logo} alt={c.abbr} className="marquee-card__logo"/>
                <span className="marquee-card__abbr">{c.abbr}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══ SERVICES FEATURE ══ */}
      <section className="section bg-white">
        <div className="container">
          
          <h2 className="section-title" style={{ textAlign: 'center', marginBottom: '3rem' }}>Core Services</h2>
          <div className="home-svc-grid">
            {[
              { label: 'Heavy Duty', sub: 'Wind Turbine Components', img: windmillImg, link: '/services/windmill', accent: '#10B981' },
              { label: 'Aerospace',  sub: 'ISRO · BrahMos · Gaganyaan', img: aerospaceImg, link: '/services/aerospace', accent: '#4F46E5' },
              { label: 'Cement',     sub: 'Heavy Industrial Parts', img: buildingImg,  link: '/services/cement',   accent: '#F59E0B' },
            ].map((s, i) => (
              <Link key={i} to={s.link} className="home-svc-card" style={{ '--hs': s.accent }}>
                <div className="home-svc-card__img-wrap">
                  <img src={s.img} alt={s.label} className="home-svc-card__img" />
                  <div className="home-svc-card__overlay" />
                </div>
                <div className="home-svc-card__body">
                  <h3 className="home-svc-card__title">{s.label}</h3>
                  <p className="home-svc-card__sub">{s.sub}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* ══ QUALITY ══ */}
      <section className="quality-section" ref={qualityRef}>
        <div className="quality-bg"/>
        <div className="container">
          <div className="quality-inner reveal">
            <div className="quality-text">
              <h2 className="quality-title">Quality is not an act,<br/><em className="quality-em">it is a habit.</em></h2>
              <div style={{ width: '56px', height: '3px', background: 'rgba(255,255,255,0.4)', borderRadius: '2px', margin: '1rem 0 1.5rem' }}/>
              <p className="quality-p">
                We maintain ISO 9001:2015 certified Quality Management with complete dimensional traceability,
                customer sign-off protocols, and zero-tolerance for defects on every aerospace component we manufacture.
              </p>
            </div>
            <div className="quality-badge float-anim">
              <div className="quality-badge__ring rotate-slow">
                <svg viewBox="0 0 160 160">
                  <circle cx="80" cy="80" r="74" stroke="rgba(255,255,255,0.3)" strokeWidth="1.5" fill="none" strokeDasharray="6 4"/>
                </svg>
              </div>
              <div className="quality-badge__body">
                <strong>ISO</strong><span>9001:2015</span><span>CERTIFIED</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ══ REVIEWS ══ */}
      <section className="section bg-white">
        <div className="container">
       
          <h2 className="section-title" style={{ textAlign: 'center', marginBottom: '3rem' }}>What Our Clients Say</h2>
          <ReviewSlider reviews={reviews}/>
        </div>
      </section>

      {/* ══ CTA ══ */}
      <section className="cta-section" ref={ctaRef}>
        <div className="cta-bg"/>
        <div className="container cta-inner reveal">
          <div>
            <h2 className="cta-title">Ready to Work Together?</h2>
            <p className="cta-sub">Send us your drawings — we respond within 24 hours.</p>
          </div>
          <div className="cta-btns">
            <Link to="/contact"  className="btn btn-white">Request a Quote</Link>
            <Link to="/products" className="btn btn-outline" style={{ borderColor: 'rgba(255,255,255,0.4)', color: '#fff' }}>
              Browse Products →
            </Link>
          </div>
        </div>
      </section>

    </div>
  );
}